import { useNavigate } from "react-router-dom";
import { AibaLogo } from "../components/site/Logo";
import { XCircle, ArrowLeft } from "lucide-react";

export default function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="relative flex min-h-screen items-center justify-center bg-[#0F172A] px-6" data-testid="payment-cancel-page">
      <div className="grid-lines absolute inset-0 opacity-50" />
      <div className="relative z-10 w-full max-w-lg rounded-2xl border border-blue-500/20 bg-blue-400/[0.03] p-10 text-center backdrop-blur-xl">
        <div className="mx-auto mb-6 flex justify-center"><AibaLogo size={38} /></div>
        <div className="mb-6 flex justify-center"><XCircle size={44} className="text-[#8AA0C0]" /></div>
        <h1 className="font-display text-2xl font-800 tracking-tighter text-white">Session interrompue</h1>
        <p className="mt-3 font-body text-sm leading-relaxed text-[#8AA0C0]">
          Le paiement a été annulé. Aucun montant n'a été prélevé. Votre place au laboratoire reste disponible.
        </p>
        <button
          data-testid="cancel-back-home"
          onClick={() => navigate("/")}
          className="mt-8 inline-flex items-center gap-2 rounded-full border border-blue-400/40 bg-blue-400/5 px-6 py-3 font-mono text-xs uppercase tracking-[0.2em] text-blue-100 transition-all duration-300 hover:bg-blue-400 hover:text-[#0F172A]"
        >
          <ArrowLeft size={14} /> Retour au laboratoire
        </button>
      </div>
    </div>
  );
}
